import classnames from 'classnames';

const isExternal = (link) =>
    typeof link === 'string' && (link.startsWith('http') || link.startsWith('//'));

export const Navmenu = ({items = [], activeItem, onSelect}) => {
    return (
        <nav className="wc-stripe-nav">
            {items.map((item) => {
                const external = isExternal(item.link);
                const isActive = activeItem === item.name;
                if (external) {
                    return (
                        <a
                            key={item.name}
                            className={classnames("wc-stripe-nav__item", {'active': isActive})}
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {item.icon && (
                                <span className="wc-stripe-nav__icon">{item.icon}</span>
                            )}
                            {item.label}
                        </a>
                    );
                }

                return (
                    <a
                        key={item.name}
                        className={classnames("wc-stripe-nav__item", {'active': isActive})}
                        onClick={() => onSelect?.(item)}
                        aria-current={isActive ? 'page' : undefined}
                    >
                        {item.icon && (
                            <span className="wc-stripe-nav__icon">{item.icon}</span>
                        )}
                        {item.label}
                    </a>
                );
            })}
        </nav>
    );
};

export default Navmenu;